import throttle from 'lodash/throttle';
import { useCallback } from 'react';

export const useOnClickThrottled = (onClick: () => void = () => {}) =>
  // biome-ignore lint/correctness/useExhaustiveDependencies: reason
  useCallback(
    // If we pass null or undefined to throttle, this will cause an exception
    throttle(onClick, 500, { trailing: false }),
    [onClick],
  );
